import React from 'react';
import axios from 'axios';
import { NumericFormat } from 'react-number-format';
import PaymentSecurity, { WebpayLogo } from '../PaymentSecurity';

class InitPaymentForm extends React.Component {
  constructor(props) {
    super(props);
    this.initTransactionRef = React.createRef();
    this.state      =  {
      license: '',
      name:    '',
      email:   '',
      amount:  '',
      obs:     '',
      url:     '',
      token:   '',
      errors:  {},
      isLoading: false
    };

    this.handleChange = this.handleChange.bind(this);
  }

  handleValidation() {
    let fields = this.state;
    let errors = {};
    let formIsValid = true;

    //License
    if (!fields["license"].trim()) {
      formIsValid = false;
      errors["license"] = "Debe ingresar la patente.";
    }

    //Name
    if (!fields["name"].trim()) {
      formIsValid = false;
      errors["name"] = "Debe ingresar el nombre.";
    }

    //Email
    if (!fields["email"]) {
      formIsValid = false;
      errors["email"] = "Debe ingresar un correo electrónico.";
    }

    if (fields.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(fields.email.trim())) {
      formIsValid = false;
      errors.email = "El correo electrónico no es válido.";
    }

    //Name
    if (!fields["amount"] || !Number.isSafeInteger(Number(fields.amount)) || Number(fields.amount) <= 0) {
      formIsValid = false;
      errors["amount"] = "Debe ingresar un monto mayor a cero.";
    }

    this.setState({ errors: errors }, () => {
      if (!formIsValid) document.getElementById(`payment-${Object.keys(errors)[0]}`)?.focus();
    });
    return formIsValid;
  }

  handleChange(event) {
    const value = event.target.value;
    const name = event.target.name;

    this.setState({
      [name]: (name === 'license') ? value.toUpperCase() : value
    });
  }

  async submit(event){
    event?.preventDefault();
    if (this.submitting) return;

    if (this.handleValidation()) {
      this.submitting = true;
      this.setState({ 'isLoading': true });

      let formData = new FormData();
      formData.append("license", this.state.license.trim());
      formData.append("name", this.state.name.trim());
      formData.append("email", this.state.email.trim());
      formData.append("amount", this.state.amount);
      formData.append("obs", this.state.obs);
      formData.append("type", 'pagos-tusmultas');
      formData.append("return_url", 'https://pagos.tusmultas.cl/retrieve-payment');

      return axios.post(
        window.env.BACKEND_API_BASE_URL + 'api/tusmultas/init-payment',
        formData, 
        {
          timeout: 30000,
      }).then(response => {
        if (!response.data.token || !response.data.url) throw new Error('Invalid Webpay response');
        this.setState({
          token : response.data.token,
          url   : response.data.url
        },() => {
            this.initTransactionRef.current.submit();
        });
        
      }).catch(e => {
        this.submitting = false;
        this.setState({ errors: { paymentProcess: "No es posible realizar pagos en este momento. Prueba nuevamente más tarde." }, isLoading: false });
      })
    } 
  }

  render() {
    const { errors, isLoading } = this.state;
    const fieldProps = (name) => ({
      id: `payment-${name}`, name, value: this.state[name], onChange: this.handleChange,
      required: true, disabled: isLoading, 'aria-invalid': Boolean(errors[name]),
      'aria-describedby': errors[name] ? `error-${name}` : undefined,
    });
    const fieldError = (name) => errors[name] && <p id={`error-${name}`} className="field-error">{errors[name]}</p>;
    return (
      <section className="payment-card" aria-labelledby="form-title">
        <div className="payment-card__heading">
          <h2 className="eyebrow" id="form-title">Pago en línea</h2>
          <div className="payment-card__intro"><p>Completa el formulario y realiza tu pago a través de</p><WebpayLogo /></div>
          <span className="heading-accent" aria-hidden="true" />
        </div>
        <form className="payment-form" noValidate onSubmit={(event) => this.submit(event)} aria-busy={isLoading}>
          <div className="payment-form__grid">
            <div className="form-field">
              <label htmlFor="payment-license">Patente</label>
              <input {...fieldProps('license')} type="text" maxLength={6} placeholder="Ej: ABCD12" autoCapitalize="characters" spellCheck={false} />
              {fieldError('license')}
            </div>
            <div className="form-field">
              <label htmlFor="payment-name">Nombre</label>
              <input {...fieldProps('name')} type="text" maxLength={50} placeholder="Ingresa tu nombre completo" autoComplete="name" />
              {fieldError('name')}
            </div>
            <div className="form-field">
              <label htmlFor="payment-email">Correo electrónico</label>
              <input {...fieldProps('email')} type="email" maxLength={100} placeholder="nombre@correo.cl" autoComplete="email" />
              {fieldError('email')}
            </div>
            <div className="form-field">
              <label htmlFor="payment-amount">Monto a pagar</label>
              <div className="amount-input"><span aria-hidden="true">$</span>
                <NumericFormat {...fieldProps('amount')} onChange={undefined} onValueChange={({ value }) => this.setState({ amount: value })} valueIsNumericString thousandSeparator="." decimalSeparator="," decimalScale={0} allowNegative={false} inputMode="numeric" placeholder="Ingresa el monto de tu cotización" />
              </div>
              {fieldError('amount')}
            </div>
            <div className="form-field form-field--full">
              <label htmlFor="payment-obs">Observaciones</label>
              <textarea id="payment-obs" name="obs" value={this.state.obs} onChange={this.handleChange} disabled={isLoading} rows={4} maxLength={500} placeholder="Ej: número de cotización o detalle del pago" />
            </div>
          </div>
          {errors.paymentProcess && <div className="payment-error" role="alert">{errors.paymentProcess}</div>}
          <button className="button button--pay" type="submit" disabled={isLoading}>
            {isLoading ? <span className="spinner" aria-hidden="true" /> : <img src={`${process.env.PUBLIC_URL}/design/lock.svg`} alt="" width="22" height="24" />}
            {isLoading ? 'Iniciando pago…' : 'Pagar'}
          </button>
          <span className="sr-only" role="status">{isLoading ? 'Iniciando pago. Serás redirigido a Webpay.' : ''}</span>
        </form>
        <PaymentSecurity />
        <form name="transbank-wrapper" ref={this.initTransactionRef} method="post" action={this.state.url} hidden>
          <input type="hidden" name="token_ws" value={this.state.token} readOnly />
        </form>
      </section>
    );
  }
}

export default InitPaymentForm;